'use strict';

import { ColourObject } from 'app/views/view_types/network/value_getters/associated_ap_value_getter';

/**
 * @ngdoc service
 * @name ims.viewControllers.service:IMSAggregator
 * @description
 * The IMSAggregator is an interface used to build aggregators.
 * These can be used to aggregate stats/values in various ways.
 */

interface IValueGetter {
    getValueForStat(stat: any, aggregator: IMSAggregator);
}

export class IMSAggregator {
    logicalName;
    displayName;

    constructor() {
        this.logicalName = 'logical_name';
        this.displayName = 'Display Name';
    }

    /**
     * Takes in an array of IMSObjects and returns an aggregate value.
     *
     * @param statArray An array of IMSObjects
     * @param valueGetter An instance of an IMSValueGetter. Purposely leaving
     * type out of here to avoid circular reference
     * @returns a number or string value
     */
    getAggValueForStatArray(
        statArray,
        valueGetter: IValueGetter,
    ): ColourObject | string | number | null | undefined {
        let valueArray = [];
        if (!statArray) return this.getAggValueForValueArray(valueArray);
        for (let i = 0; i < statArray.length; i++) {
            let value = valueGetter.getValueForStat(statArray[i], this);
            valueArray.push(value);
        }
        return this.getAggValueForValueArray(valueArray);
    }

    /**
     * Takes in an array of values and returns an aggregate value.
     *
     * @param valueArray An array of values
     * @returns Number number or string value
     */
    getAggValueForValueArray(valueArray): number {
        // This should be subclassed for each aggregator type
        throw new Error('Not implemented');
    }
}
